import { WineProduct, WineMeta, PriceTable, Rating, Image, ProductTag, Country, Area, District, Grape } from '../../app/core/interfaces/generated/graphql';

const defaultImage: Image = {
  __typename: 'Image',
  id: 'img-1001',
  original: 'https://magento.supervin.dk/media/catalog/product/c/h/chateau_belfort_medoc.png',
  large: 'https://magento.supervin.dk/media/catalog/product/c/h/chateau_belfort_medoc.png',
  small: 'https://magento.supervin.dk/media/catalog/product/c/h/chateau_belfort_medoc.png',
  thumbnail: 'https://magento.supervin.dk/media/catalog/product/c/h/chateau_belfort_medoc.png',
};

const defaultPriceTable: PriceTable = {
  __typename: 'PriceTable',
  id: 'pt-1',
  pricings: [
    {
      __typename: 'PriceTablePricing',
      amount: 8900,
      amountIncVat: 8900,
      minQty: 1,
      maxQty: 5,
      id: 'ptp-1',
    },
  ],
};

const discountPriceTable: PriceTable = {
  __typename: 'PriceTable',
  id: 'pt-2',
  pricings: [
    {
      __typename: 'PriceTablePricing',
      amount: 8900,
      amountIncVat: 8900,
      minQty: 1,
      maxQty: 5,
      id: 'ptp-2',
      discount: {
        __typename: 'Discount',
        amount: 6900,
        amountIncVat: 6900,
        from: '2026-01-01T00:00:00Z',
        to: '2026-12-31T23:59:59Z',
      },
    },
  ],
};

const quantityPriceTable: PriceTable = {
  __typename: 'PriceTable',
  id: 'pt-3',
  pricings: [
    {
      __typename: 'PriceTablePricing',
      amount: 8900,
      amountIncVat: 8900,
      minQty: 1,
      maxQty: 5,
      id: 'ptp-3a',
    },
    {
      __typename: 'PriceTablePricing',
      amount: 7900,
      amountIncVat: 7900,
      minQty: 6,
      maxQty: 11,
      id: 'ptp-3b',
    },
    {
      __typename: 'PriceTablePricing',
      amount: 6900,
      amountIncVat: 6900,
      minQty: 12,
      maxQty: null,
      id: 'ptp-3c',
    },
  ],
};

const defaultCountryEnt: Country = {
  __typename: 'Country',
  id: 'country-fr',
  title: 'Frankrig',
  urlPath: '/lande/frankrig',
};

const defaultAreaEnt: Area = {
  __typename: 'Area',
  id: 'area-bordeaux',
  title: 'Bordeaux',
  urlPath: '/omraader/bordeaux',
};

const defaultDistrictEnt: District = {
  __typename: 'District',
  id: 'dist-margaux',
  title: 'Margaux',
  urlPath: '/distrikter/margaux',
};

const defaultGrapesV2: Grape[] = [
  { __typename: 'Grape', id: 'grape-cs', title: 'Cabernet Sauvignon', urlPath: '/druer/cabernet-sauvignon' },
  { __typename: 'Grape', id: 'grape-merlot', title: 'Merlot', urlPath: '/druer/merlot' },
  { __typename: 'Grape', id: 'grape-pv', title: 'Petit Verdot', urlPath: '/druer/petit-verdot' },
];

const defaultMeta: WineMeta = {
  __typename: 'WineMeta',
  alcohol: '13.5%',
  area: 'Bordeaux',
  countryName: 'Frankrig',
  countryEnt: defaultCountryEnt,
  areaEnt: defaultAreaEnt,
  districtName: 'Margaux',
  districtEnt: defaultDistrictEnt,
  grapes: ['Cabernet Sauvignon', 'Merlot', 'Petit Verdot'],
  grapesV2: defaultGrapesV2,
  vintage: 2020,
  productType: 'Rødvin',
  contentsCl: 75,
  contents: '75 cl',
  contentLabel: '75 cl',
  wineType: 'Rødvin',
  producer: {
    __typename: 'ProducerV2',
    id: 'prod-1',
    title: 'Château Margaux',
    urlPath: '/producenter/chateau-margaux',
  },
  producerName: 'Château Margaux',
  units: {
    __typename: 'Unit',
    id: 'unit-fl',
    shortName: 'fl.',
    title: 'Flaske',
  },
  powerLabel: 'Mellem',
  powerValue: 3,
  sweetnessLabel: 'Tør',
  sweetnessValue: 1,
  wineBodyLabel: 'Medio',
  wineBodyValue: 3,
  savingPotential: '2025–2035',
  serving: '16–18°C',
  foods: [
    { __typename: 'Food', id: '1', label: 'Oksekød', icon: 'beef-icon', path: '/mad/oksekoed' },
    { __typename: 'Food', id: '2', label: 'Lam', icon: 'lamb-icon', path: '/mad/lam' },
  ],
  tastingNotes: [
    { __typename: 'TastingNote', id: '1', title: 'Mørke bær', icon: 'berry-icon' },
    { __typename: 'TastingNote', id: '2', title: 'Cedertræ', icon: 'cedar-icon' },
    { __typename: 'TastingNote', id: '3', title: 'Vanilje', icon: 'vanilla-icon' },
  ],
  ratings: [
    {
      __typename: 'Rating',
      id: '1',
      name: 'Robert Parker',
      isPreviousVintage: false,
      label: '95/100',
      rating: 95,
      ratingPoint: '95',
      maxRatingSymbols: '100',
      starCount: 5,
      review: 'Exceptionel årgang med stor dybde og kompleksitet.',
      reviewSnippet: 'Exceptionel årgang...',
      reviewer: {
        __typename: 'Reviewer',
        id: 'rev-1',
        title: 'Robert Parker',
        image: 'https://magento.supervin.dk/cdn-cgi/image/quality=85,format=auto,height=50/media/catalog/product/r/e/reviewer_parker.jpg',
        ratingType: 'points',
      },
    },
  ],
};

const defaultTags: ProductTag[] = [
  { __typename: 'ProductTag', text: 'Økologisk', icon: '/assets/images/organic-icon.svg', color: '#4CAF50', altText: 'Økologisk vin' },
];

function createBaseProduct(): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '1001',
    title: 'Château Margaux 2020',
    sku: 'CM2020',
    vismaProductNumber: 'VP1001',
    nodePath: 'vin/chateau-margaux-2020',
    inStock: true,
    stock: 42,
    canBeAddedToCart: true,
    published: true,
    priceTable: defaultPriceTable,
    image: defaultImage,
    images: [defaultImage],
    meta: defaultMeta,
    productDescription: 'En fremragende Bordeaux vin fra den berømte Château Margaux vingård. Denne vin udtrykker terroir med elegance og dybde.',
    tastingNotesDescription: 'Smag af mørke bær, cedertræ og krydderier med en lang, silkeblød afslutning.',
    shortText: 'Bordeaux, Frankrig · Rødvin · 75 cl',
    tags: defaultTags,
    organic: true,
    defaultQuantity: 1,
  };
}

/**
 * Creates a mock WineProduct with sensible defaults.
 * Override any field via the `overrides` parameter.
 */
export function createMockWineProduct(overrides?: Partial<WineProduct>): WineProduct {
  return { ...createBaseProduct(), ...overrides };
}

/** Product with an active discount on all pricings. */
export function createDiscountedProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Barolo Riserva 2018 – Tilbud',
    id: '1002',
    vismaProductNumber: 'VP1002',
    priceTable: discountPriceTable,
    ...overrides,
  });
}

/** Product with quantity-based pricing tiers (1+, 6+, 12+). */
export function createQuantityPricedProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Chianti Classico 2021 – Mængderabat',
    id: '1003',
    vismaProductNumber: 'VP1003',
    priceTable: quantityPriceTable,
    ...overrides,
  });
}

/** Product with group voucher pricing (vismaProductNumber matches mock voucher). */
export function createGroupVoucherProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Firmavoucher – Rioja Reserva 2019',
    id: '1004',
    vismaProductNumber: 'VP-GV-100',
    suggestedRetailPrice: '12900',
    ...overrides,
  });
}

/** Product with multiple expert ratings. */
export function createProductWithRatings(overrides?: Partial<WineProduct>): WineProduct {
  const ratings: Rating[] = [
    {
      __typename: 'Rating',
      id: '1',
      name: 'Robert Parker',
      isPreviousVintage: false,
      label: '96/100',
      rating: 96,
      ratingPoint: '96',
      maxRatingSymbols: '100',
      starCount: 5,
      review: 'En dybt koncentreret vin med bemærkelsesværdig kompleksitet.',
      reviewSnippet: 'En dybt koncentreret vin...',
      reviewer: { __typename: 'Reviewer', id: 'rev-1', title: 'Robert Parker', ratingType: 'points' },
    },
    {
      __typename: 'Rating',
      id: '2',
      name: 'Wine Spectator',
      isPreviousVintage: false,
      label: '93/100',
      rating: 93,
      ratingPoint: '93',
      maxRatingSymbols: '100',
      starCount: 5,
      review: 'Elegant og velbalanceret med stor dybde.',
      reviewSnippet: 'Elegant og velbalanceret...',
      reviewer: { __typename: 'Reviewer', id: 'rev-2', title: 'Wine Spectator', ratingType: 'points' },
    },
    {
      __typename: 'Rating',
      id: '3',
      name: 'Jancis Robinson',
      isPreviousVintage: false,
      label: '18/20',
      rating: 18,
      ratingPoint: '18',
      maxRatingSymbols: '20',
      starCount: 4,
      review: 'Strålende balance mellem frugt og tannin.',
      reviewSnippet: 'Strålende balance...',
      reviewer: { __typename: 'Reviewer', id: 'rev-3', title: 'Jancis Robinson', ratingType: 'points' },
    },
  ];

  return createMockWineProduct({
    title: 'Barolo DOCG 2017 – Topbedømt',
    id: '1005',
    vismaProductNumber: 'VP1005',
    meta: { ...defaultMeta, ratings },
    ...overrides,
  });
}

/** Product with no ratings. */
export function createProductWithoutRatings(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Hverdagsvin – Côtes du Rhône 2022',
    id: '1006',
    vismaProductNumber: 'VP1006',
    meta: { ...defaultMeta, ratings: [] },
    ...overrides,
  });
}

/** Product that is out of stock. */
export function createOutOfStockProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Udsolgt – Amarone 2016',
    id: '1007',
    vismaProductNumber: 'VP1007',
    inStock: false,
    stock: 0,
    canBeAddedToCart: false,
    ...overrides,
  });
}

/** Minimal product with very few fields populated. */
export function createMinimalProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '1008',
    title: 'Simpel Rødvin',
    sku: 'SR1008',
    vismaProductNumber: 'VP1008',
    priceTable: defaultPriceTable,
    inStock: true,
    stock: 10,
    canBeAddedToCart: true,
    ...overrides,
  } as WineProduct;
}

/** B2B product. */
export function createB2BProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Erhvervsvin – Chablis 2021',
    id: '1009',
    vismaProductNumber: 'VP1009',
    isB2b: true,
    ...overrides,
  });
}

/** Product with custom badge HTML instead of discount label. */
export function createCustomBadgeProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'Nyheder – Sancerre 2023',
    id: '1010',
    vismaProductNumber: 'VP1010',
    customBadgeHTML: '<span style="background:#F7941E;color:#fff;padding:4px 8px;border-radius:4px;">NYHED</span>',
    ...overrides,
  });
}

/** Pre-order / en primeur product. */
export function createPreorderProduct(overrides?: Partial<WineProduct>): WineProduct {
  return createMockWineProduct({
    title: 'En Primeur – Pauillac 2024',
    id: '1011',
    vismaProductNumber: 'VP1011',
    isEnPrimeur: true,
    preorderDate: '2026-09-01',
    availableFrom: '2026-09-01T00:00:00Z',
    ...overrides,
  });
}

/**
 * Real product example: Damilano Barbera d'Asti DOCG "Zero Sette" 2024
 * Based on actual API response — use for realistic Storybook stories and tests.
 */
export function createDamilanoBarberaProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '164542',
    inStock: true,
    defaultQuantity: 6,
    preorderDate: null,
    canBeAddedToCart: true,
    nodePath: 'damilano-barbera-d-asti-docg-zero-sette-2024',
    ctaLink: null,
    pageWhitelist: [],
    ctaTitle: null,
    ctaStockText: null,
    isB2b: false,
    vimeoId: '1158397536',
    youTubeId: null,
    hideDiscountCountdown: false,
    title: 'Damilano Barbera d\'Asti DOCG "Zero Sette" 2024',
    body: '',
    supplierName: null,
    pdfText: null,
    vismaProductNumber: '392391024',
    sku: '392391024',
    vismaSku: '8023587249961',
    has360BottleImage: true,
    packaging: '6 stk. papkasse',
    closure: 'Kork',
    shortText:
      '94 point. Det her er Barbera, som jeg allerbedst kan lide den. "12 of the Best Barberas from Italy\'s Piedmont: An impressive wine at a...',
    hidePriceTable: false,
    hideShippingCountdown: false,
    hideSupervinAdvantages: false,
    productDescription:
      '<p><em><strong>"12 of the Best Barberas from Italy\'s Piedmont:</strong></em> <em>An impressive wine at a bargain price" </em><strong>– Vinepair </strong>(tidl. årg.)</p>',
    tastingNotesDescription:
      'Damilano Barbera d\'Asti \u201CZero Sette\u201D 2024 viser sig frem i glasset en smuk solbær-mørk farve. Den ungdommelige duft åbner med liflige florale noter af røde roser og violer, der ledsages af saftige kirsebær, solbær og mørke blommer.',
    productionMethodDescription:
      'Damilano Barbera d\'Asti \u201CZeroSette\u201D er fremstillet på 100 % Barbera fra en 11 hektar stor vinmark i Casorzo i Monferrato.',
    producerDescription: '',
    highlightText: null,
    videoLink: '',
    topCta: {
      __typename: 'TopCta',
      text: null,
      icon: 'CTA_DISCOUNT_TAG',
      type: 'discount_countdown',
    },
    isLeftover: false,
    isEnPrimeur: false,
    customBadgeHTML: null,
    productImageBadge: null,
    images: [
      {
        __typename: 'Image',
        id: '43178',
        large: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
        height: 5306,
        width: 1496,
        small: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
        roles: ['image', 'small_image', 'thumbnail', 'front_image'],
      },
      {
        __typename: 'Image',
        id: '43177',
        large: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_180_1.png',
        height: 5309,
        width: 1522,
        small: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_180_1.png',
        roles: ['back_image'],
      },
      {
        __typename: 'Image',
        id: '43176',
        large: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_kasse_360_1.png',
        height: 1915,
        width: 3173,
        small: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_kasse_360_1.png',
        roles: ['packaging_image'],
      },
    ],
    image: {
      __typename: 'Image',
      id: '43178',
      original: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
      large: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
      small: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
      thumbnail: 'https://magento.supervin.dk/media/catalog/product/3/9/392391024_flaske_360_1.png',
      height: 5306,
      width: 1496,
    },
    productAuthor: {
      __typename: 'ProductAuthor',
      id: '1286',
      name: 'Thor Gottschalk',
      tagline: 'Vinekspert WSET 3',
      image: 'https://a.storyblok.com/f/106593/675x675/a78a0e8b09/thor-gottschalk-rasmussen-supervin-novin-sej_4590.jpg',
    },
    tags: [
      {
        __typename: 'ProductTag',
        altText: 'Italien',
        color: '',
        icon: '/assets/country_icons/it_round.svg',
        text: '',
        type: 'country',
      },
    ],
    priceTable: {
      __typename: 'PriceTable',
      id: '164542',
      pricings: [
        {
          __typename: 'PriceTablePricing',
          id: '215016',
          amountIncVat: 19995,
          maxQty: 5,
          minQty: 1,
          discount: null,
        },
        {
          __typename: 'PriceTablePricing',
          id: '215282',
          amountIncVat: 17495,
          maxQty: -1,
          minQty: 6,
          discount: {
            __typename: 'Discount',
            id: '215282',
            to: '2026-03-15T23:00:00+00:00',
            from: '2026-03-08T23:00:00+00:00',
            amountExVat: 7996,
            amountIncVat: 9995,
          },
        },
      ],
    },
    meta: {
      __typename: 'WineMeta',
      id: '164542',
      units: { __typename: 'Unit', shortName: 'fl.' },
      ratings: [
        {
          __typename: 'Rating',
          id: '63447',
          label: null,
          rating: 94,
          name: 'Winewherever, Rasmus Christensen',
          starCount: null,
          review:
            'Det her er Barbera, som jeg allerbedst kan lide den. Frisk, energisk, mineralsk og med en frugt og syre, der taktfuldt leder an.',
          isPreviousVintage: false,
          reviewSnippet: '94 point. Det her er Barbera, som jeg allerbedst kan lide den.',
        },
        {
          __typename: 'Rating',
          id: '62821',
          label: null,
          rating: 93,
          name: 'Vinonyme',
          starCount: null,
          review:
            'Hold nu kæft, det her er bare hammer saftigt! Blommekompot, kirsebæryoghurt og krydren fra vaniljestang.',
          isPreviousVintage: false,
          reviewSnippet:
            '93 point. Hold nu kæft, det her er bare hammer saftigt! ... Jeg er vild med når Barbera, som her, får dette koncentrerede og saftige udtryk.',
        },
        {
          __typename: 'Rating',
          id: '62822',
          label: 'Value: ★★★★★ 5/6',
          rating: 0,
          name: 'Vinonyme',
          starCount: null,
          review: '',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '63418',
          label: null,
          rating: 93,
          name: 'Dorthe Kristine',
          starCount: null,
          review:
            'Damilano Barbera d\'Asti DOCG \u201CZero Sette\u201D 2024 er som en energisk italiener med røde læber og hurtige replikker.',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62105',
          label: null,
          rating: 92,
          name: 'Wine Spectator',
          starCount: null,
          review:
            'Sleek and elegant, this linear and bracing version is pure and refined, boasting rose, cherry, raspberry and iron flavors.',
          isPreviousVintage: true,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62106',
          label: null,
          rating: 91,
          name: 'James Suckling',
          starCount: null,
          review:
            'Ripe and dark-fruited with burnt orange peel and notes of cured meat and spices. Full-bodied and deep with compact but polished tannins.',
          isPreviousVintage: true,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62954',
          label: null,
          rating: 91,
          name: 'Vin.connaisseur',
          starCount: null,
          review:
            'Saftig og levende Barbera. Kirsebær, hindbær, let viol og frisk syre. Ingen unødig sødme – bare ren, drikkevenlig Barbera med masser af value.',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62955',
          label: 'Value: ★★★★★ 5/6',
          rating: 0,
          name: 'Vin.connaisseur',
          starCount: null,
          review: '',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '63450',
          label: null,
          rating: 91,
          name: 'Houlberg',
          starCount: null,
          review:
            'Duftmæssigt er det ingen marmeladefed eller fyldig Barbera ... nej tværtimod er der nærmere lidt Nebbiolo feeling med violer, tørrede rosenblade, læder.',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62219',
          label: null,
          rating: 0,
          name: 'Sara d\'Amato',
          starCount: null,
          review:
            'Appealing and vibrant, this barbera offers plenty of pep but also more complexity and structure than expected for the price.',
          isPreviousVintage: true,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62220',
          label: 'Value Rating: ★★★★★ 5/5  ',
          rating: 0,
          name: 'Sara d\'Amato',
          starCount: null,
          review: '',
          isPreviousVintage: true,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '62197',
          label: '12 of the Best Barberas from Italy\'s Piedmont',
          rating: 0,
          name: 'Vinepair',
          starCount: null,
          review:
            '12 of the Best Barberas from Italy\'s Piedmont – An impressive wine at a bargain price | Price: $17',
          isPreviousVintage: true,
          reviewSnippet: null,
        },
      ],
      foods: [
        { __typename: 'Food', id: '4', label: 'Fjerkræ', icon: '/pub/media/supervin/food/fjerkrae.png', path: '/vin-til/fjerkra', pdfIcon: '/pub/media/supervin/food/fjer.png' },
        { __typename: 'Food', id: '17', label: 'Svinekød', icon: '/pub/media/supervin/food/svinekod_1_.png', path: '/vin-til/svinekod', pdfIcon: '/pub/media/supervin/food/svinekod.png' },
        { __typename: 'Food', id: '13', label: 'Hygge', icon: '/pub/media/supervin/food/hygge_2.png', path: '/vin-til/hygge', pdfIcon: '/pub/media/supervin/food/hygge_1.png' },
        { __typename: 'Food', id: '8', label: 'Kalv', icon: '/pub/media/supervin/food/kalv_1.png', path: '/vin-til/kalv', pdfIcon: '/pub/media/supervin/food/kalv.png' },
        { __typename: 'Food', id: '5', label: 'Lam', icon: '/pub/media/supervin/food/lam.png', path: '/vin-til/lam', pdfIcon: '/pub/media/supervin/food/lam_1.png' },
        { __typename: 'Food', id: '3', label: 'Ost', icon: '/pub/media/supervin/food/ost_1.png', path: '/vin-til/ost', pdfIcon: '/pub/media/supervin/food/ost.png' },
        { __typename: 'Food', id: '20', label: 'Pasta', icon: '/pub/media/supervin/food/pasta_1.png', path: '/vin-til/pasta', pdfIcon: '/pub/media/supervin/food/pasta.png' },
        { __typename: 'Food', id: '21', label: 'Pizza', icon: '/pub/media/supervin/food/pizza_1_.png', path: '/vin-til/pizza', pdfIcon: '/pub/media/supervin/food/pizza.png' },
        { __typename: 'Food', id: '10', label: 'Svampe', icon: '/pub/media/supervin/food/svampe.png', path: '/vin-til/svampe', pdfIcon: '/pub/media/supervin/food/svampe_1_.png' },
        { __typename: 'Food', id: '16', label: 'Tapas', icon: '/pub/media/supervin/food/tapas.png', path: '/vin-til/tapas', pdfIcon: '/pub/media/supervin/food/tapas_1.png' },
        { __typename: 'Food', id: '7', label: 'Vildt', icon: '/pub/media/supervin/food/vildt.png', path: '/vin-til/vildt', pdfIcon: '/pub/media/supervin/food/vildt_1.png' },
      ],
      grapesV2: [{ __typename: 'Grape', id: '130', title: 'Barbera', urlPath: '/druer/barbera' }],
      barrelTypes: [{ __typename: 'Barrel', id: '2', title: 'Betontank', urlPath: 'Default/betontank' }],
      countryEnt: { __typename: 'Country', id: '10', title: 'Italien', icon: '/assets/country_icons/it_round.svg', urlPath: '/vin/italien' },
      areaEnt: { __typename: 'Area', id: '12', title: 'Piemonte', urlPath: '/vin/italien/piemonte' },
      districtEnt: { __typename: 'District', id: '130', title: 'Barbera d\u00B4Asti', urlPath: '/vin/italien/piemonte/barbera-dasti' },
      powerLabel: '3) Medium',
      powerValue: 3,
      sweetnessLabel: '2) Tør',
      sweetnessValue: 2,
      wineBodyLabel: '3) Medium',
      wineBodyValue: 3,
      tastingNotes: [
        { __typename: 'TastingNote', id: '33', title: 'Blomme', icon: '/pub/media/supervin/tasting_note/plum.png', path: 'smagenote/blomme' },
        { __typename: 'TastingNote', id: '41', title: 'Rose', icon: '/pub/media/supervin/tasting_note/rose.png', path: 'smagenote/rose' },
        { __typename: 'TastingNote', id: '21', title: 'Røde kirsebær', icon: '/pub/media/supervin/tasting_note/cherries.png', path: 'smagenote/rode-kirsebar' },
        { __typename: 'TastingNote', id: '20', title: 'Vanilje', icon: '/pub/media/supervin/tasting_note/vanilla.png', path: 'smagenote/vanilje' },
        { __typename: 'TastingNote', id: '46', title: 'Viol', icon: '/pub/media/supervin/tasting_note/violet_1_.png', path: 'smagenote/viol' },
      ],
      nutritionalInfoUrl: 'https://rtwm.wineappening.com/ea/94170',
      allergens: ['Sulferdioxid/ Sulfitter'],
      savingPotential: '5-8 år fra høståret',
      alcohol: '14,5',
      contents: '0,75',
      contentLabel: '75 cl',
      serving: '14-17°C',
      producer: {
        __typename: 'ProducerV2',
        id: '887',
        title: 'Damilano',
        urlPath: '/producent/damilano',
        contentImage: '/media/supervin/producer/chi-siamo-1890-img-opt.jpg',
        description: '<p>Velkommen til Damilano – et af Piemontes og Italiens fineste vinhuse!</p>',
      },
      wineType: 'Vin',
      productType: 'Vin',
      productSubType: 'Rødvin',
      vintage: 2024,
      portType: '',
      energyLabel: '',
      energyLabelDoc: null,
      productDataSheet: null,
      acidContent: null,
      residualSugar: null,
      measurementUnit: 'L',
    },
    suggestedRetailPrice: null,
    ...overrides,
  } as WineProduct;
}

/**
 * Real En Primeur product: Château Mouton Rothschild 1.Cru Classé Pauillac 2024
 * High-end Bordeaux future purchase with preorderDate, isEnPrimeur=true, no productAuthor.
 */
export function createMoutonRothschildEnPrimeurProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '164349',
    inStock: true,
    defaultQuantity: 1,
    preorderDate: '2027-06-29T22:00:00+02:00',
    canBeAddedToCart: true,
    nodePath: 'en-primeur-chateau-mouton-rothschild-1-cru-classe-pauillac-2024-i-traekasse',
    ctaLink: null,
    pageWhitelist: [],
    ctaTitle: null,
    ctaStockText: null,
    isB2b: false,
    vimeoId: null,
    youTubeId: null,
    hideDiscountCountdown: false,
    title: 'EN PRIMEUR Chateau Mouton-Rothschild 1.Cru Classé Pauillac 2024 i trækasse',
    body: '',
    supplierName: null,
    pdfText: null,
    vismaProductNumber: '332945724',
    sku: '332945724',
    vismaSku: '332945724',
    has360BottleImage: false,
    packaging: '6 stk. trækasse',
    closure: 'Kork',
    shortText: '96 points. This is just brilliant - fresh, lively, zingy and ample. Lovely finesse too. There\'s acidity for sure, but there\'s creaminess to counter it...',
    hidePriceTable: false,
    hideShippingCountdown: false,
    hideSupervinAdvantages: false,
    productDescription:
      '<p>Årgangens bedste Bordeaux? Jeb Dunnuck er meget tæt på at slå det fast\u2026</p>\n' +
      '<p>En ekstremt kræsen selektion af perfekt modne druer fra 50 år gamle vinstokke på dybe grusbanker er nøglen til dette fabelagtige blend af 93% Cabernet Sauvignon og 7% Merlot.</p>',
    tastingNotesDescription: '',
    productionMethodDescription: '',
    producerDescription: '',
    highlightText: null,
    videoLink: '',
    topCta: null,
    isLeftover: false,
    isEnPrimeur: true,
    customBadgeHTML: null,
    productImageBadge: null,
    images: [
      {
        __typename: 'Image',
        id: '42064',
        large: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
        height: 1200,
        width: 336,
        small: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
        roles: ['image', 'small_image', 'thumbnail', 'swatch_image', 'front_image', 'packaging_image'],
      },
    ],
    image: {
      __typename: 'Image',
      id: '42064',
      original: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
      large: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
      small: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
      thumbnail: 'https://magento.supervin.dk/media/catalog/product/3/3/332945724.png',
      height: 1200,
      width: 336,
    },
    productAuthor: null,
    tags: [
      {
        __typename: 'ProductTag',
        altText: 'Frankrig',
        color: '',
        icon: '/assets/country_icons/fr_round.svg',
        text: '',
        type: 'country',
      },
    ],
    priceTable: {
      __typename: 'PriceTable',
      id: '164349',
      pricings: [
        {
          __typename: 'PriceTablePricing',
          id: '104031',
          amountIncVat: 270895,
          maxQty: -1,
          minQty: 1,
          discount: null,
        },
      ],
    },
    meta: {
      __typename: 'WineMeta',
      id: '164349',
      units: { __typename: 'Unit', shortName: 'fl.' },
      ratings: [
        {
          __typename: 'Rating',
          id: '52969',
          label: null,
          rating: 96,
          name: 'Falstaff',
          starCount: null,
          review: 'Dark ruby, opaque core, purple reflections, subtle brightening on the rim. Fine cassis, black cherries, orange blossom, nougat, very inviting bouquet.',
          isPreviousVintage: false,
          reviewSnippet: null,
        },
        {
          __typename: 'Rating',
          id: '52973',
          label: null,
          rating: 96,
          name: 'Decanter',
          starCount: null,
          review: 'This is just brilliant - fresh, lively, zingy and ample. Lovely finesse too.',
          isPreviousVintage: false,
          reviewSnippet: '96 points. This is just brilliant - fresh, lively, zingy and ample.',
        },
        {
          __typename: 'Rating',
          id: '52968',
          label: '97-98 Point',
          rating: 97,
          name: 'James Suckling',
          starCount: null,
          review: 'This really has length and it has the depth to improve with age. 93% cabernet sauvignon and 7% merlot.',
          isPreviousVintage: false,
          reviewSnippet: '97-98 points. This really has length and it has the depth to improve with age',
        },
        {
          __typename: 'Rating',
          id: '52975',
          label: '95-97 Point',
          rating: 95,
          name: 'Jeb Dunnuck',
          starCount: null,
          review: 'One of the wines of the vintage, if not the wine of the vintage.',
          isPreviousVintage: false,
          reviewSnippet: '95-97 points. One of the wines of the vintage.',
        },
      ],
      foods: [
        { __typename: 'Food', id: '17', label: 'Svinekød', icon: '/pub/media/supervin/food/svinekod_1_.png', path: '/vin-til/svinekod', pdfIcon: '/pub/media/supervin/food/svinekod.png' },
        { __typename: 'Food', id: '8', label: 'Kalv', icon: '/pub/media/supervin/food/kalv_1.png', path: '/vin-til/kalv', pdfIcon: '/pub/media/supervin/food/kalv.png' },
        { __typename: 'Food', id: '5', label: 'Lam', icon: '/pub/media/supervin/food/lam.png', path: '/vin-til/lam', pdfIcon: '/pub/media/supervin/food/lam_1.png' },
        { __typename: 'Food', id: '6', label: 'Okse', icon: '/pub/media/supervin/food/okse.png', path: '/vin-til/okse', pdfIcon: '/pub/media/supervin/food/okse_1.png' },
        { __typename: 'Food', id: '7', label: 'Vildt', icon: '/pub/media/supervin/food/vildt.png', path: '/vin-til/vildt', pdfIcon: '/pub/media/supervin/food/vildt_1.png' },
      ],
      grapesV2: [
        { __typename: 'Grape', id: '8', title: 'Cabernet Sauvignon', urlPath: '/druer/cabernet-sauvignon' },
        { __typename: 'Grape', id: '7', title: 'Merlot', urlPath: '/druer/merlot' },
      ],
      barrelTypes: [{ __typename: 'Barrel', id: '3', title: 'Fad-/egetræslagring', urlPath: 'Default/fad-egetraslagring' }],
      countryEnt: { __typename: 'Country', id: '3', title: 'Frankrig', icon: '/assets/country_icons/fr_round.svg', urlPath: '/vin/frankrig' },
      areaEnt: { __typename: 'Area', id: '4', title: 'Bordeaux', urlPath: '/vin/frankrig/bordeaux' },
      districtEnt: { __typename: 'District', id: '28', title: 'Pauillac', urlPath: '/vin/frankrig/bordeaux/pauillac' },
      powerLabel: '4) Kraftig',
      powerValue: 4,
      sweetnessLabel: '2) Tør',
      sweetnessValue: 2,
      wineBodyLabel: '4) Lidt tanninrig',
      wineBodyValue: 4,
      tastingNotes: [
        { __typename: 'TastingNote', id: '43', title: 'Cedertræ', icon: '/pub/media/supervin/tasting_note/cedar.png', path: 'smagenote/cedertra' },
        { __typename: 'TastingNote', id: '17', title: 'Kaffe', icon: '/pub/media/supervin/tasting_note/coffee-beans_1.png', path: 'smagenote/kaffe' },
        { __typename: 'TastingNote', id: '52', title: 'Mynte', icon: '/pub/media/supervin/tasting_note/peppermint_1_.png', path: 'smagenote/mynte' },
        { __typename: 'TastingNote', id: '39', title: 'Solbær', icon: '/pub/media/supervin/tasting_note/berries.png', path: 'smagenote/solbar' },
        { __typename: 'TastingNote', id: '46', title: 'Viol', icon: '/pub/media/supervin/tasting_note/violet_1_.png', path: 'smagenote/viol' },
      ],
      nutritionalInfoUrl: null,
      allergens: null,
      savingPotential: '+25 år fra høståret',
      alcohol: '13',
      contents: '0,75',
      contentLabel: '75 cl',
      serving: '16-18°C',
      producer: {
        __typename: 'ProducerV2',
        id: '186',
        title: 'Chateau Mouton Rothschild',
        urlPath: '/producent/chateau-mouton-rothschild',
        contentImage: null,
        description: null,
      },
      wineType: 'Vin',
      productType: 'Vin',
      productSubType: 'Rødvin',
      vintage: 2024,
      portType: '',
      energyLabel: '',
      energyLabelDoc: null,
      productDataSheet: null,
      acidContent: null,
      residualSugar: null,
      measurementUnit: 'L',
    },
    suggestedRetailPrice: null,
    ...overrides,
  } as WineProduct;
}

/**
 * Real Organic product: Masso Antico Primitivo Organic 2025 ØKO
 * Organic-certified Italian Primitivo with organic tag, volume pricing tiers, and productAuthor.
 */
export function createMassoAnticoOrganicProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '166268',
    inStock: true,
    defaultQuantity: 6,
    preorderDate: null,
    canBeAddedToCart: true,
    nodePath: 'masso-antico-primitivo-organic-2025-oko',
    ctaLink: null,
    pageWhitelist: [],
    ctaTitle: null,
    ctaStockText: null,
    isB2b: false,
    vimeoId: null,
    youTubeId: null,
    hideDiscountCountdown: false,
    title: 'Masso Antico Primitivo Organic 2025 ØKO',
    body: '',
    supplierName: null,
    pdfText: null,
    vismaProductNumber: '392385425',
    sku: '392385425',
    vismaSku: '8009620872587@4',
    has360BottleImage: false,
    packaging: '6 stk. papkasse',
    closure: 'Kork',
    shortText: '98 points. Vores mest solgte rødvin, Masso Antico Primitivo, i en særligt eksklusiv udgave \u2013 hvor samtlige druer er nøje selekterede fra en...',
    hidePriceTable: false,
    hideShippingCountdown: false,
    hideSupervinAdvantages: false,
    productDescription:
      '<p class="MsoNormal">Vores mest solgte rødvin, Masso Antico Primitivo, i en særligt eksklusiv udgave \u2013 hvor samtlige druer er nøje selekterede fra en økologisk certificeret enkeltmark!</p>',
    tastingNotesDescription:
      'Masso Antico Primitivo Organic 2025 funkler i glasset med en dyb, mørk brombærfarve\u2026 Næsen skruer helt op for den økologiske frugtcharme.',
    productionMethodDescription:
      'Vinen er fremstillet på 100% Primitivo (Zinfandel), som Tenute Masso Anticos selekterer fra vingårdens egne, økologisk dyrkede topmarker i hjertet af Salento, Apulien.',
    producerDescription: '',
    highlightText: null,
    videoLink: '',
    topCta: null,
    isLeftover: false,
    isEnPrimeur: false,
    customBadgeHTML: null,
    productImageBadge: null,
    images: [
      {
        __typename: 'Image',
        id: '44625',
        large: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
        height: 800,
        width: 232,
        small: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
        roles: ['image', 'small_image', 'thumbnail', 'swatch_image', 'front_image'],
      },
    ],
    image: {
      __typename: 'Image',
      id: '44625',
      original: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
      large: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
      small: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
      thumbnail: 'https://magento.supervin.dk/media/catalog/product/3/9/392385425_kopier.jpg',
      height: 800,
      width: 232,
    },
    productAuthor: {
      __typename: 'ProductAuthor',
      id: '1285',
      name: 'Isak Broe',
      tagline: 'Vinekspert DipWSET',
      image: 'https://a.storyblok.com/f/106593/675x675/c1ab5ad019/isak-broe-supervin-2852.jpg',
    },
    tags: [
      {
        __typename: 'ProductTag',
        altText: 'Italien',
        color: '',
        icon: '/assets/country_icons/it_round.svg',
        text: '',
        type: 'country',
      },
      {
        __typename: 'ProductTag',
        altText: '',
        color: 'green',
        icon: '',
        text: 'Økologisk',
        type: 'organic',
      },
    ],
    priceTable: {
      __typename: 'PriceTable',
      id: '166268',
      pricings: [
        {
          __typename: 'PriceTablePricing',
          id: '583707',
          amountIncVat: 13995,
          maxQty: 5,
          minQty: 1,
          discount: null,
        },
        {
          __typename: 'PriceTablePricing',
          id: '583708',
          amountIncVat: 11495,
          maxQty: -1,
          minQty: 6,
          discount: null,
        },
      ],
    },
    meta: {
      __typename: 'WineMeta',
      id: '166268',
      units: { __typename: 'Unit', shortName: 'fl.' },
      ratings: [
        {
          __typename: 'Rating',
          id: '64099',
          label: null,
          rating: 98,
          name: 'Best Italian Wines Annuario',
          starCount: null,
          review: '',
          isPreviousVintage: false,
          reviewSnippet: '98 points.',
        },
        {
          __typename: 'Rating',
          id: '64102',
          label: null,
          rating: 92,
          name: 'Gilbert & Gaillard',
          starCount: null,
          review: 'A stellar quality Primitivo well worth trying. Double Gold Winner.',
          isPreviousVintage: true,
          reviewSnippet: '92 points. A stellar quality Primitivo well worth trying. Double Gold Winner.',
        },
        {
          __typename: 'Rating',
          id: '64100',
          label: null,
          rating: 92,
          name: 'Winewherever, Rasmus Christensen',
          starCount: null,
          review: 'Guf for Primitivoelskere!',
          isPreviousVintage: true,
          reviewSnippet: '92 point. Guf for Primitivoelskere!',
        },
        {
          __typename: 'Rating',
          id: '64101',
          label: null,
          rating: 92,
          name: 'Mad og Monopolet',
          starCount: null,
          review: 'Denne Masso Antico Primitivo lever op til sit rygte - der er nemlig smæk på alle tangenter.',
          isPreviousVintage: true,
          reviewSnippet: '92 point. Denne Masso Antico Primitivo lever op til sit rygte.',
        },
      ],
      foods: [
        { __typename: 'Food', id: '18', label: 'Grill', icon: '/pub/media/supervin/food/grill.png', path: '/vin-til/grill', pdfIcon: '/pub/media/supervin/food/grill_1.png' },
        { __typename: 'Food', id: '17', label: 'Svinekød', icon: '/pub/media/supervin/food/svinekod_1_.png', path: '/vin-til/svinekod', pdfIcon: '/pub/media/supervin/food/svinekod.png' },
        { __typename: 'Food', id: '13', label: 'Hygge', icon: '/pub/media/supervin/food/hygge_2.png', path: '/vin-til/hygge', pdfIcon: '/pub/media/supervin/food/hygge_1.png' },
        { __typename: 'Food', id: '6', label: 'Okse', icon: '/pub/media/supervin/food/okse.png', path: '/vin-til/okse', pdfIcon: '/pub/media/supervin/food/okse_1.png' },
        { __typename: 'Food', id: '20', label: 'Pasta', icon: '/pub/media/supervin/food/pasta_1.png', path: '/vin-til/pasta', pdfIcon: '/pub/media/supervin/food/pasta.png' },
        { __typename: 'Food', id: '21', label: 'Pizza', icon: '/pub/media/supervin/food/pizza_1_.png', path: '/vin-til/pizza', pdfIcon: '/pub/media/supervin/food/pizza.png' },
      ],
      grapesV2: [{ __typename: 'Grape', id: '29', title: 'Primitivo', urlPath: '/druer/primitivo' }],
      barrelTypes: [{ __typename: 'Barrel', id: '3', title: 'Fad-/egetræslagring', urlPath: 'Default/fad-egetraslagring' }],
      countryEnt: { __typename: 'Country', id: '10', title: 'Italien', icon: '/assets/country_icons/it_round.svg', urlPath: '/vin/italien' },
      areaEnt: { __typename: 'Area', id: '18', title: 'Apulien', urlPath: '/vin/italien/apulien' },
      districtEnt: { __typename: 'District', id: '121', title: 'Salento', urlPath: '/vin/italien/apulien/salento' },
      powerLabel: '4) Kraftig',
      powerValue: 4,
      sweetnessLabel: '2) Tør',
      sweetnessValue: 2,
      wineBodyLabel: '3) Medium',
      wineBodyValue: 3,
      tastingNotes: [
        { __typename: 'TastingNote', id: '33', title: 'Blomme', icon: '/pub/media/supervin/tasting_note/plum.png', path: 'smagenote/blomme' },
        { __typename: 'TastingNote', id: '45', title: 'Brombær', icon: '/pub/media/supervin/tasting_note/raspberry.png', path: 'smagenote/brombar' },
        { __typename: 'TastingNote', id: '55', title: 'Chokolade', icon: '/pub/media/supervin/tasting_note/chocolate.png', path: 'smagenote/chokolade' },
        { __typename: 'TastingNote', id: '2', title: 'Lakrids', icon: '/pub/media/supervin/tasting_note/licorice.png', path: 'smagenote/lakrids' },
        { __typename: 'TastingNote', id: '6', title: 'Rosiner', icon: '/pub/media/supervin/tasting_note/raisins.png', path: 'smagenote/rosiner' },
      ],
      nutritionalInfoUrl: 'https://elabel.scantrust.com/default/#/?uid=b76f8e23-fa5b-4bb6-904b-31b3d4a77256',
      allergens: null,
      savingPotential: '6-8 år fra høståret',
      alcohol: '14',
      contents: '0,75',
      contentLabel: '75 cl',
      serving: '15-17°C',
      producer: {
        __typename: 'ProducerV2',
        id: '6',
        title: 'Masso Antico',
        urlPath: '/producent/masso-antico',
        contentImage: null,
        description: '<p>Masso Antico er ejet af Schenk, et stolt og traditionsrigt schweizisk vinfirma.</p>',
      },
      wineType: 'Vin',
      productType: 'Vin',
      productSubType: 'Rødvin',
      vintage: 2025,
      portType: '',
      energyLabel: '',
      energyLabelDoc: null,
      productDataSheet: null,
      acidContent: null,
      residualSugar: null,
      measurementUnit: 'L',
    },
    suggestedRetailPrice: null,
    ...overrides,
  } as WineProduct;
}

/**
 * Real product: Rui Roboredo Madeira Altos da Beira 2023
 * Last bottles leftover product with "last_bottles" badge, topCta with CTA_WINE_BOTTLE icon,
 * isLeftover=true, single flat-price discount (x6 price for last items).
 */
export function createLastBottlesProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '109474',
    inStock: true,
    defaultQuantity: 1,
    preorderDate: null,
    canBeAddedToCart: true,
    nodePath: 'rui-roboredo-madeira-altos-da-beira-2023',
    ctaLink: null,
    pageWhitelist: [],
    ctaTitle: null,
    ctaStockText: null,
    isB2b: false,
    vimeoId: '1142966674',
    youTubeId: null,
    hideDiscountCountdown: false,
    title: 'Rui Roboredo Madeira Altos da Beira 2023',
    body: '',
    supplierName: null,
    pdfText: null,
    vismaProductNumber: '352801923',
    sku: '352801923',
    vismaSku: '5609851523253@3',
    has360BottleImage: false,
    packaging: '6 stk. papkasse',
    closure: 'Kork',
    shortText: '92 point. Højlands Tempranillo med nerve og aromatik ... En meget levende og energisk vin som bare er virkelig behagelig at drikke. Her får man noget for pengene.',
    hidePriceTable: false,
    hideShippingCountdown: false,
    hideSupervinAdvantages: false,
    productDescription:
      '<p>Dette fantastiske røverkøb er nu endnu tættere på Ribera del Duero end tidligere!</p>',
    tastingNotesDescription:
      'Altos da Beira 2023 sejler mørk kirsebærrød rundt i glasset… Næsen lokker med flot solmodne og samtidig køligt vibrerende frugtaromaer.',
    productionMethodDescription:
      'Altos da Beira Tinto 2023 er fremstillet på et iberisk superblend af 90% Tempranillo og 10% Touriga Nacional.',
    producerDescription: '',
    highlightText: null,
    videoLink: '',
    topCta: {
      __typename: 'TopCta',
      text: 'UNDER 6 fl. TILBAGE - BEDSTE PRIS V. 1 STK.',
      icon: 'CTA_WINE_BOTTLE',
      type: 'text',
    },
    isLeftover: true,
    isEnPrimeur: false,
    customBadgeHTML: null,
    productImageBadge: {
      __typename: 'ProductImageBadge',
      type: 'last_bottles',
      value: '',
      text: null,
      badgeColor: null,
      textColor: null,
    },
    images: [
      {
        __typename: 'Image',
        id: '39576',
        large: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
        height: 600,
        width: 157,
        small: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
        roles: ['image', 'small_image', 'thumbnail', 'swatch_image'],
      },
    ],
    image: {
      __typename: 'Image',
      id: '39576',
      original: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
      large: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
      small: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
      thumbnail: 'https://magento.supervin.dk/media/catalog/product/3/5/352801923.jpg',
      height: 600,
      width: 157,
    },
    productAuthor: null,
    tags: [
      {
        __typename: 'ProductTag',
        altText: 'Portugal',
        color: '',
        icon: '/assets/country_icons/pt_round.svg',
        text: '',
        type: 'country',
      },
    ],
    priceTable: {
      __typename: 'PriceTable',
      id: '109474',
      pricings: [
        {
          __typename: 'PriceTablePricing',
          id: '44122',
          amountIncVat: 10995,
          maxQty: -1,
          minQty: 1,
          discount: {
            __typename: 'Discount',
            id: '44122',
            to: '2080-01-01T00:00:00+00:00',
            from: '2020-01-01T00:00:00+00:00',
            amountExVat: 7196,
            amountIncVat: 8995,
          },
        },
      ],
    },
    meta: {
      __typename: 'WineMeta',
      id: '109474',
      units: { __typename: 'Unit', shortName: 'fl.' },
      ratings: [
        {
          __typename: 'Rating',
          id: '50749',
          label: null,
          rating: 92,
          name: 'Winewherever, Rasmus Christensen',
          starCount: null,
          review: 'Højlands Tempranillo med nerve og aromatik. Mørk frugt, sådan skal Tempranillo være, men også med friske og halvsyrlige bærnoter. En meget levende og energisk vin som bare er virkelig behagelig at drikke.',
          isPreviousVintage: false,
          reviewSnippet: '92 point. Højlands Tempranillo med nerve og aromatik ... En meget levende og energisk vin som bare er virkelig behagelig at drikke. Her får man noget for pengene.',
        },
        {
          __typename: 'Rating',
          id: '50438',
          label: null,
          rating: 91,
          name: 'Mad og Monopolet',
          starCount: null,
          review: 'Det er helt vildt, hvad du får for pengene, hvis du lige sætter kursen mod Portugal.',
          isPreviousVintage: false,
          reviewSnippet: '91 point. Det er helt vildt, hvad du får for pengene.',
        },
        {
          __typename: 'Rating',
          id: '51937',
          label: null,
          rating: 91,
          name: 'Vinvalget',
          starCount: null,
          review: 'Fyldig omfavnende næse af frugtkompot med mørke kirsebær, mørke blommer, søde brombær.',
          isPreviousVintage: false,
          reviewSnippet: '91 point. Flot balance mellem frugt og mineralitet.',
        },
      ],
      foods: [
        { __typename: 'Food', id: '4', label: 'Fjerkræ', icon: '/pub/media/supervin/food/fjerkrae.png', path: '/vin-til/fjerkra', pdfIcon: '/pub/media/supervin/food/fjer.png' },
        { __typename: 'Food', id: '18', label: 'Grill', icon: '/pub/media/supervin/food/grill.png', path: '/vin-til/grill', pdfIcon: '/pub/media/supervin/food/grill_1.png' },
        { __typename: 'Food', id: '6', label: 'Okse', icon: '/pub/media/supervin/food/okse.png', path: '/vin-til/okse', pdfIcon: '/pub/media/supervin/food/okse_1.png' },
        { __typename: 'Food', id: '20', label: 'Pasta', icon: '/pub/media/supervin/food/pasta_1.png', path: '/vin-til/pasta', pdfIcon: '/pub/media/supervin/food/pasta.png' },
        { __typename: 'Food', id: '16', label: 'Tapas', icon: '/pub/media/supervin/food/tapas.png', path: '/vin-til/tapas', pdfIcon: '/pub/media/supervin/food/tapas_1.png' },
      ],
      grapesV2: [
        { __typename: 'Grape', id: '4', title: 'Tinta Roriz (Tempranillo)', urlPath: '/druer/tinta-roriz-tempranillo' },
        { __typename: 'Grape', id: '6', title: 'Touriga Nacional', urlPath: '/druer/touriga-nacional' },
      ],
      barrelTypes: [{ __typename: 'Barrel', id: '1', title: 'Ståltank', urlPath: 'Default/staltank' }],
      countryEnt: { __typename: 'Country', id: '1', title: 'Portugal', icon: '/assets/country_icons/pt_round.svg', urlPath: '/vin/portugal' },
      areaEnt: { __typename: 'Area', id: '47', title: 'Beira Interior', urlPath: '/vin/portugal/beira-interior' },
      districtEnt: { __typename: 'District', id: null, title: 'Øvrige', urlPath: null },
      powerLabel: '3) Medium',
      powerValue: 3,
      sweetnessLabel: '2) Tør',
      sweetnessValue: 2,
      wineBodyLabel: '4) Lidt tanninrig',
      wineBodyValue: 4,
      tastingNotes: [
        { __typename: 'TastingNote', id: '45', title: 'Brombær', icon: '/pub/media/supervin/tasting_note/raspberry.png', path: 'smagenote/brombar' },
        { __typename: 'TastingNote', id: '2', title: 'Lakrids', icon: '/pub/media/supervin/tasting_note/licorice.png', path: 'smagenote/lakrids' },
        { __typename: 'TastingNote', id: '27', title: 'Sorte kirsebær', icon: '/pub/media/supervin/tasting_note/cherries_1.png', path: 'smagenote/sorte-kirsebar' },
        { __typename: 'TastingNote', id: '46', title: 'Viol', icon: '/pub/media/supervin/tasting_note/violet_1_.png', path: 'smagenote/viol' },
      ],
      nutritionalInfoUrl: null,
      allergens: ['Sulferdioxid/ Sulfitter'],
      savingPotential: '4-6 år fra høståret',
      alcohol: '13',
      contents: '0,75',
      contentLabel: '75 cl',
      serving: '16-18°C',
      producer: {
        __typename: 'ProducerV2',
        id: '71',
        title: 'Rui Roboredo Madeira',
        urlPath: '/producent/rui-roboredo-madeira',
        contentImage: '/media/supervin/producer/Rui_Madeira.jpg',
        description: '',
      },
      wineType: 'Vin',
      productType: 'Vin',
      productSubType: 'Rødvin',
      vintage: 2023,
      portType: '',
      energyLabel: '',
      energyLabelDoc: null,
      productDataSheet: null,
      acidContent: null,
      residualSugar: null,
      measurementUnit: 'L',
    },
    suggestedRetailPrice: null,
    ...overrides,
  } as WineProduct;
}

/**
 * Real product: Tesch Riesling Lohrer Berg Vintage Box
 * B2B product with discount countdown CTA, no ratings, no badge, high-value tasting box.
 * Unit: "ks." (kasse), 450cl, no vintage, productSubType "Smagekasser".
 */
export function createDiscountCountdownProduct(overrides?: Partial<WineProduct>): WineProduct {
  return {
    __typename: 'WineProduct',
    id: '164523',
    inStock: true,
    defaultQuantity: 1,
    preorderDate: null,
    canBeAddedToCart: true,
    nodePath: 'tesch-riesling-lohrer-berg-vintage-box',
    ctaLink: null,
    pageWhitelist: [],
    ctaTitle: null,
    ctaStockText: null,
    isB2b: true,
    vimeoId: null,
    youTubeId: null,
    hideDiscountCountdown: false,
    title: 'Tesch Riesling Löhrer Berg Vintage Box',
    body: '',
    supplierName: null,
    pdfText: null,
    vismaProductNumber: '491102500',
    sku: '491102500',
    vismaSku: '4015276619241',
    has360BottleImage: false,
    packaging: '6 stk. papkasse',
    closure: 'Skruelåg',
    shortText: '"We present a true rarity. A strictly limited library box featuring one bottle each of LÖHRER BERG single-vineyard Riesling from the past six vintages – 2019 to 2024...',
    hidePriceTable: false,
    hideShippingCountdown: false,
    hideSupervinAdvantages: false,
    productDescription:
      '<p>Riesling-fans, det er nu I skal læse rigtig godt med. Martin Tesch har eksklusivt til Supervins kunder sammensat en sjælden Vertikal-smagekasse med 6 forskellige årgange.</p>',
    tastingNotesDescription: '',
    productionMethodDescription: '',
    producerDescription: '',
    highlightText: null,
    videoLink: '',
    topCta: {
      __typename: 'TopCta',
      text: null,
      icon: 'CTA_DISCOUNT_TAG',
      type: 'discount_countdown',
    },
    isLeftover: false,
    isEnPrimeur: false,
    customBadgeHTML: null,
    productImageBadge: null,
    images: [
      {
        __typename: 'Image',
        id: '42618',
        large: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
        height: 1200,
        width: 1547,
        small: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
        roles: ['packaging_image'],
      },
    ],
    image: {
      __typename: 'Image',
      id: '42618',
      original: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
      large: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
      small: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
      thumbnail: 'https://magento.supervin.dk/media/catalog/product/4/9/491102500_kasse_1.jpg',
      height: 1200,
      width: 1547,
    },
    productAuthor: null,
    tags: [
      {
        __typename: 'ProductTag',
        altText: 'Tyskland',
        color: '',
        icon: '/assets/country_icons/de_round.svg',
        text: '',
        type: 'country',
      },
    ],
    priceTable: {
      __typename: 'PriceTable',
      id: '164523',
      pricings: [
        {
          __typename: 'PriceTablePricing',
          id: '203845',
          amountIncVat: 156970,
          maxQty: -1,
          minQty: 1,
          discount: {
            __typename: 'Discount',
            id: '203845',
            to: '2026-03-20T23:00:00+00:00',
            from: '2026-03-10T23:00:00+00:00',
            amountExVat: 74396,
            amountIncVat: 92995,
          },
        },
      ],
    },
    meta: {
      __typename: 'WineMeta',
      id: '164523',
      units: { __typename: 'Unit', shortName: 'ks.' },
      ratings: [],
      foods: [],
      grapesV2: [{ __typename: 'Grape', id: '24', title: 'Riesling', urlPath: '/druer/riesling' }],
      barrelTypes: null,
      countryEnt: { __typename: 'Country', id: '5', title: 'Tyskland', icon: '/assets/country_icons/de_round.svg', urlPath: '/vin/tyskland' },
      areaEnt: { __typename: 'Area', id: '57', title: 'Nahe', urlPath: '/vin/tyskland/nahe' },
      districtEnt: { __typename: 'District', id: null, title: 'Øvrige', urlPath: null },
      powerLabel: null,
      powerValue: null,
      sweetnessLabel: null,
      sweetnessValue: null,
      wineBodyLabel: null,
      wineBodyValue: null,
      tastingNotes: [],
      nutritionalInfoUrl: null,
      allergens: ['Sulferdioxid/ Sulfitter'],
      savingPotential: null,
      alcohol: '13',
      contents: '4,5',
      contentLabel: '450 cl',
      serving: null,
      producer: {
        __typename: 'ProducerV2',
        id: '19',
        title: 'Weingut Tesch',
        urlPath: '/producent/weingut-tesch',
        contentImage: '/media/supervin/producer/Tesch.jpg',
        description: '',
      },
      wineType: 'Vin',
      productType: 'Vin',
      productSubType: 'Smagekasser',
      vintage: null,
      portType: '',
      energyLabel: '',
      energyLabelDoc: null,
      productDataSheet: null,
      acidContent: null,
      residualSugar: null,
      measurementUnit: 'L',
    },
    suggestedRetailPrice: null,
    ...overrides,
  } as WineProduct;
}

// Re-export for convenience
export { defaultImage, defaultPriceTable, discountPriceTable, quantityPriceTable, defaultMeta, defaultTags };
